import { BookExamAttemptModel } from '../student/book-exam-attempt.model';
import { DescriptionModel } from '../shared/description.model';
import {QuestionModel} from '../questions/question.model';
import {DropdownModel} from '../component/dropdown.model';
import {AssetsHelper} from '../extensions/assets-helper.model';
import {generateQuestionList} from '../questions/question-generator';
import {QuestionExtendedModel} from '../questions/question-extended.model';
export class BookVersionModel {

  static BookImgTypes = {
    bookZeroNoTitle: 'Book-0-no-title.png',
    bookOneNoTitle: 'Book-1-no-title.png',
    bookTwoNoTitle: 'Book-2-no-title.png',
    bookThreeNoTitle: 'Book-3-no-title.png',
    bookFourNoTitle: 'Book-4-no-title.png',
    bookFiveNoTitle: 'Book-5-no-title.png',
    list: function (): string[] {
      return [
        this.bookZeroNoTitle,
        this.bookOneNoTitle,
        this.bookTwoNoTitle,
        this.bookThreeNoTitle,
        this.bookFourNoTitle,
        this.bookFiveNoTitle
      ];
    },
    dropdownList: function (): DropdownModel[] {

      const array = DropdownModel.generateFromKeys(this.list());

      return array;
    }
  };


  _id: string;
  bookId: string;
  /**
   * The addon id for Chargebee pricing so we can map
   * This version of the book to a product in chargebee
   */
  addOnId: string;
  /**
   * The addon id for Chargebee shipping pricing so we can map
   * This version of the book to a shipping pricing. Maybe should
   * just be related to the country code of the user who is buying?
   */
  shippingAddOnId: string;
  name: string;
  edition: string;
  editionNumber: number;
  age: string;
  grade: number;
  bookNumber: number;
  publisher: string;
  imgType: string;
  numPages: number;
  description: string;
  translatedDescription = new DescriptionModel();
  isPublished: boolean;
  integrations: BookVersionIntegrationModel[] = [];
  exams: BookVersionIntegrationModel[] = [];

  publishedAt: Date;
  createdAt: Date;
  updatedAt: Date;

  static generateModel(json: any): BookVersionModel {

    const version = new BookVersionModel();
    version._id = json._id;
    version.bookId = json.bookId;
    version.addOnId = json.addOnId;
    version.name = json.name;
    version.edition = json.edition;
    version.editionNumber = json.editionNumber;
    version.age = json.age;
    version.grade = json.grade;
    version.bookNumber = json.bookNumber;
    version.publisher = json.publisher;
    version.imgType = json.imgType;
    version.numPages = json.numPages;
    version.description = json.description;
    version.isPublished = json.isPublished;

    if (json.translatedDescription) {
      version.translatedDescription = DescriptionModel.generateModel(json.translatedDescription);
    }

    if (json.integrations) {

      version.integrations = BookVersionIntegrationModel.generateModels(json.integrations);
      for (const integration of version.integrations) {
        if (integration.type === BookVersionIntegrationModel.IntegrationTypes.Exam) {
          version.exams.push(integration);
        }
      }

    }

    if (json.publishedAt) {
      version.publishedAt = new Date(json.publishedAt);
    }

    if (json.createdAt) {
      version.createdAt = new Date(json.createdAt);
    }

    if (json.updatedAt) {
      version.updatedAt = new Date(json.updatedAt);
    }

    return version;

  }

  static generateModels(jsonList: any[]): BookVersionModel[] {

    const list = [];

    for (const json of jsonList) {
      list.push(this.generateModel(json));
    }

    return list;

  }

  bookVersionImgURL(): string {

    return './assets/books/' + this.imgType;
  }

  addAttempts(attempts: BookExamAttemptModel[]) {
    for (const attempt of attempts) {
      for (const integration of this.integrations) {
        integration.addAttempt(attempt);
      }
    }
  }

  numChaptersFinished(): number {

    let numFinished = 0;

    for (const integration of this.exams) {
      if (integration.successfulAttempt) {
        numFinished++;
      }
    }

    return numFinished;

  }

  numChapters(): number {

    if (this.exams.length > 0) {
      return this.exams.length;
    }

    return 1;
  }

  chaptersFinishedFraction(): number {

    console.log('num chapters: ' + this.numChapters());
    console.log('num chapters finished: ' + this.numChaptersFinished());

    return this.numChaptersFinished() / this.numChapters();

  }

}

export class BookVersionIntegrationModel {

  static IntegrationTypes = {
    Exam: 'Exam',
    Passcode: 'Passcode',
    VideoHelp: 'VideoHelp',
    list: function() {
      return [
        this.Exam,
        this.Passcode,
        this.VideoHelp
      ];
    },
    dropdownList: function (): DropdownModel[] {
      return DropdownModel.generateFromKeys(this.list());
    }
  };

  static PassphraseTypes = {
    none: 'none',
    number: 'number',
    string: 'string',
    code: 'code',
    list: function() {
      return [
        this.none,
        this.number,
        this.string,
        this.code
      ];
    },
    dropdownList: function (): DropdownModel[] {
      return DropdownModel.generateFromKeys(this.list());
    }
  };

  _id: string;
  name: string;
  names = new DescriptionModel();
  monitorNames = new DescriptionModel();
  type: string;
  iconName: string;
  category: string;
  passphraseType: string;
  passphraseLength: number;
  passphrase: string;
  page: number;
  chapter: number;
  numCorrect: number;
  videoURL: string;
  coinReward: string;

  rewards: BookVersionIntegrationRewardModel[] = [];
  questions: BookVersionIntegrationQuestionModel[] = [];
  includedQuestions: QuestionExtendedModel[] = [];

  successfulAttempt: BookExamAttemptModel = null;
  attempts: BookExamAttemptModel[] = [];

  createdAt: Date;
  updatedAt: Date;

  static generateModel(json: any): BookVersionIntegrationModel {

    const integration = new BookVersionIntegrationModel();
    integration._id = json._id;
    integration.name = json.name;
    integration.type = json.type;
    integration.iconName = json.iconName;
    integration.category = json.category;
    integration.passphraseType = json.passphraseType;
    integration.passphraseLength = json.passphraseLength;
    integration.passphrase = json.passphrase;
    integration.page = json.page;
    integration.chapter = json.chapter;
    integration.numCorrect = json.numCorrect;
    integration.videoURL = json.videoURL;
    integration.coinReward = json.coinReward;

    if (json.names) {
      integration.names = DescriptionModel.generateModel(json.names);
    }

    if (json.monitorNames) {
      integration.monitorNames = DescriptionModel.generateModel(json.monitorNames);
    }

    if (json.rewards) {
      integration.rewards = BookVersionIntegrationRewardModel.generateModels(json.rewards);
    }

    if (json.questions) {
      integration.questions = BookVersionIntegrationQuestionModel.generateModels(json.questions);
    }

    if (json.includedQuestions) {
      integration.includedQuestions = generateQuestionList(json.includedQuestions);
    }

    if (json.createdAt) {
      integration.createdAt = new Date(json.createdAt);
    }

    if (json.updatedAt) {
      integration.updatedAt = new Date(json.updatedAt);
    }

    return integration;

  }

  static generateModels(jsonList: any[]): BookVersionIntegrationModel[] {

    const list = [];

    for (const json of jsonList) {
      list.push(this.generateModel(json));
    }

    return list;

  }

  iconURL(): string {

    if (this.category) {

      return AssetsHelper.categoryIconURL(this.category);
    }

    if (this.iconName) {

      return './assets/skill-icons/' + this.iconName + '.png';
    }

    return null;
  }

  numQuestions(): number {

    let numQ = 0;

    for (const q of this.questions) {
      numQ += q.numQuestions;
    }

    return numQ;
  }


  numAttempts(): number {

    let attempts = 0;

    if (this.attempts.length) {
      attempts += this.attempts.length;
    }

    if (this.successfulAttempt) {
      attempts += 1;
    }

    return attempts;

  }

  addAttempt(attempt: BookExamAttemptModel) {
    if (this._id === attempt.integrationId) {
      if (attempt.success) {
        this.successfulAttempt = attempt;
        this.attempts.push(attempt);
      } else {
        this.attempts.push(attempt);
      }
    }
  }

}

export class BookVersionIntegrationRewardModel {

  _id: string;
  uniqueId: string;
  numItems: number;

  static generateModel(json: any): BookVersionIntegrationRewardModel {

    const r = new BookVersionIntegrationRewardModel();
    r._id = json._id;
    r.uniqueId = json.uniqueId;
    r.numItems = json.numItems;

    return r;

  }

  static generateModels(jsonList: any[]): BookVersionIntegrationRewardModel[] {

    const list = [];

    for (const json of jsonList) {
      list.push(this.generateModel(json));
    }

    return list;

  }

}

export class BookVersionIntegrationQuestionModel {

  questionId: string;
  question: QuestionModel;

  numQuestions: number;

  static generateModel(json: any): BookVersionIntegrationQuestionModel {

    const q = new BookVersionIntegrationQuestionModel();
    q.questionId = json.questionId;
    q.numQuestions = json.numQuestions;

    return q;

  }

  static generateModels(jsonList: any[]): BookVersionIntegrationQuestionModel[] {

    const list = [];

    for (const json of jsonList) {
      list.push(this.generateModel(json));
    }

    return list;

  }

}
